import { apiClient } from "../../Service";
import { communitiesListCollection } from "@/common/api/Services/Community/Transformer";
import { snakeToCamelCase } from "@/common/common";
async function searchCommunity(invitationCode) {
    const client = apiClient();
    return await client.post("/appv2/community/search", { search_input: invitationCode })
        .then((response) => { return response.community; });
}
async function joinCommunity(communityId, invitationCode, localPassword) {
    const client = apiClient();
    return await client.post("/appv2/community/join", {
        community_id: communityId,
        invitation_code: invitationCode,
        community_password: localPassword
    })
        .then((response) => { return response; });
}
async function getUserCommunities() {
    const client = apiClient();
    return await client.get("/appv2/community/index")
        .then((res) => communitiesListCollection(snakeToCamelCase(res)));
}
async function leaveCommunity(communityId) {
    const client = apiClient();
    return await client.post("/appv2/community/leave", {
        community_id: communityId
    })
        .then((response) => { return response; });
}
export { searchCommunity, joinCommunity, getUserCommunities, leaveCommunity };
